import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { CustomSelect } from "../../components/CustomSelect/CustomSelect.component";
import { CustomButton } from "../../components/CustomButton/CustomButton.component";

const TransactionViewModal = ({
  rejectModal,
  receiptRejection,
  rejectremarksOption,
  handleRejectChange,
  setRejectModal,
  onRejectTransaction,
  discardModal,
  discardStatusModal,
  setDiscardModal,
  setDiscardStatusModal,
  onDiscardReceipt,
  onStatusDiscard,
  handleSubmit,
}) => {
  return (
    <>
      <Dialog open={rejectModal}>
        <DialogTitle> Receipt Rejection Remarks </DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <CustomSelect
              value={receiptRejection}
              options={rejectremarksOption}
              isClearable={true}
              onChange={(selectedOption) => handleRejectChange(selectedOption)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={() => setRejectModal(false)}
            color="secondary"
            title="CLOSE"
          />

          <CustomButton
            onClick={handleSubmit(onRejectTransaction)}
            startIcon={<Warning />}
            title="PROCEED"
          />
        </DialogActions>
      </Dialog>

      {/* DISCARD MODAL */}
      <Dialog open={discardModal || discardStatusModal}>
        <DialogTitle>Are you sure you want to Discard?</DialogTitle>
        <DialogActions>
          <CustomButton
            onClick={() => {
              setDiscardModal(false);
              setDiscardStatusModal(false);
            }}
            color="secondary"
            title="CLOSE"
          />

          <CustomButton
            startIcon={<Warning />}
            onClick={() => {
              if (discardModal) {
                handleSubmit(onDiscardReceipt)();
              } else if (discardStatusModal) {
                handleSubmit(onStatusDiscard)();
              }
              setDiscardModal(false);
              setDiscardStatusModal(false);
            }}
            title="PROCEED"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TransactionViewModal;
